import { Component, h, render, createRef } from 'preact';

class TcrComponent extends Component
{
    constructor(props)
    {
        super(props);

        this.setStateAsync = this.setStateAsync.bind(this);
    }

    setStateAsync(state)
    {
        return new Promise((resolve) => {
            this.setState(state, resolve);
        });
    }

    cleanText(value)
    {
        //convert all html tags into unicode chars
        value = value.replace(/</g, '&lt;');
        value = value.replace(/>/g, '&gt;');

        return value;
    }

    applyEnvironment(value)
    {
        if (typeof this.props.env === 'object')
        {
            for (let key in this.props.env)
            {
                //value = value.replaceAll('{' + key + '}', this.props.env[key]);
                value = value.replace(new RegExp('{' + key + '}', 'g'), this.props.env[key]);
            }
        }
        return value;
    }

    applyFindText(value)
    {
        if (typeof this.props.findText === 'string' && this.props.findText.length > 0)
        {
            value = value.replace(new RegExp('(' + this.props.findText + ')', 'gi'), '<mark>$1</mark>');
        }

        return value;
    }

    applyMarkdown(value)
    {

        //apply bold text to markdown syntax **TXT**
        value = value.replace(/\*\*(.+?)\*\*(?!\*)/g,'<b>$1</b>');
        //value = value.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
        
        //apply italic text to markdown syntax *TXT*
        //value = value.replace(/\*(.*?)\*/g, '<i>$1</i>');
        value = value.replace(/\*([^*><]+)\*/g, '<i>$1</i>');
        
        //apply underline text to markdown syntax _TXT_
        value = value.replace(/(^|\s)\_([^\_><]+)\_(\s|$)/g, '$1<u>$2</u>$3');

        //apply strikethrough text to markdown syntax ~~TXT~~
        value = value.replace(/\~\~([^\~><]+)\~\~/g, '<s>$1</s>');

        //apply code text to markdown syntax `TXT`
        value = value.replace(/\`([^\`><]+)\`/g, '<span class="code">$1</span>');

        //apply link block to markdown syntax [TXT](URL)
        value = value.replace(/\[(.*?)\]\((.*?)\)/g, '<a href="$2" target="_blank" title="$2">$1</a>');

        return value;
    }

    parseMarkdown(text, annotations = [])
    {
        //split on one or more \n
        let lines = text.split(/\n/g);
        //console.log(lines.join('\n'));

        try
        {
            for (let i = 0; i < lines.length; i++)
            {
                if (typeof lines[i] != 'string')
                {
                    lines[i] = '';
                    continue;
                }

                //convert all html tags into unicode chars
                lines[i] = lines[i].replace(/</g, '&lt;');
                lines[i] = lines[i].replace(/>/g, '&gt;');

                // Apply HEADING
                if (lines[i].match(/^#+\s/g))
                {
                    lines[i] = lines[i].replace(/^#\s(.*)$/g, '<h1>$1</h1>');
                    lines[i] = lines[i].replace(/^##\s(.*)$/g, '<h2>$1</h2>');
                    lines[i] = lines[i].replace(/^###\s(.*)$/g, '<h3>$1</h3>');
                    lines[i] = lines[i].replace(/^####\s(.*)$/g, '<h4>$1</h4>');
                    lines[i] = lines[i].replace(/^#####\s(.*)$/g, '<h5>$1</h5>');
                    lines[i] = lines[i].replace(/^######\s(.*)$/g, '<h6>$1</h6>');
                }
                else if (lines[i].match(/^\s*-\s/g))
                {
                    lines[i] = lines[i].replace(/^\s*(-|\*)\s(.*)$/g, '<ul><li>$2</li></ul>');
                }
                else if (lines[i].match(/^\s*\d+\.\s/g))
                {
                    lines[i] = lines[i].replace(/^\s*(\d+\.)\s(.*)$/g, '<ol><li>$2</li></ol>');
                }
                else if (lines[i].match(/^\s*```/g))
                {
                    lines[i] = '<code>';
                    do {
                        i++;
                        lines[i] = lines[i].replace(/</g, '&lt;');
                        lines[i] = lines[i].replace(/>/g, '&gt;');
                        lines[i] += '\n';
                    }
                    while (i < lines.length && !lines[i].match(/^\s*```/g))
                    lines[i] = '</code>';
                    continue;
                }
                else if (lines[i] != '')
                {
                    lines[i] = '<p>' + lines[i] + '</p>';
                }
                else
                {
                    lines[i] = '';
                }

                //apply bold text to markdown syntax **BOLD**
                lines[i] = lines[i].replace(/(^|[^*])\*\*([^*]+?)\*\*([^*]|$)/g, '$1' + '<b>' + '$2'.trim() + '</b>' + '$3');

                //apply italic text to markdown syntax *ITALIC*
                lines[i] = lines[i].replace(/(^|[^*])\*([^*]+?)\*([^*]|$)/g, '$1' + '<i>' + '$2'.trim() + '</i>' + '$3');

                //apply code to markdown syntax `CODE`
                lines[i] = lines[i].replace(/(^|[^`])`([^`]+?)`([^`]|$)/g, '$1<code class="inline">' + '$2'.trim() + '</code>$3');
                
                //apply annotations
                for (let annotation of annotations)
                {
                    if (annotation.type == 'file_citation' && annotation.text.match(/【\d+†source】/g))
                    {
                        lines[i] = lines[i].replace(/【(\d+)†source】/g, `<span class="source" title="${annotation.file_citation.quote}">` + '[$1]</span>');
                        //lines[i] = lines[i].replace(annotation.text, `<span title="${annotation.file_citation.quote}">[?]</span>`);
                    }
                }
                //remove other annotations
                lines[i] = lines[i].replace(/【.+】/g, '');
                
                //【15†source】
                // if (lines[i].match(/(【\d+†source】)/g))
                // {
                //     lines[i] = lines[i].replace(/【(\d+)†source】/g, '<sup>$1</sup>');
                // }
                

            }
        }
        catch (e)
        {
            console.log(e);
        }

        //console.log(lines.join('\n'));
        let result = lines.filter(Boolean).join('');

        // join lists
        result = result.replace(/<\/ul>(\s*)<ul>/g, '$1');
        result = result.replace(/<\/ol>(\s*)<ol>/g, '$1');

        return result;
    }
}

export { TcrComponent, h, render, createRef };